import { type FC } from 'react'

export const ProductPageAttributeGroupDivider: FC = () => {
  return <hr className="border-t border-t-dark-primary-min" />
}
